var exports = {
  "X": "GlassBorder__7ItdlM",
};

module.exports = exports;
